import { Form, Input, Checkbox, Button, Typography, Col } from 'antd'
const { Title, Paragraph } = Typography

import { useTranslation } from 'react-i18next'
import { FormItemPasswordProgress } from './'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const RegisterForm = ({ onSubmit }) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const [submitDisabled, setSubmitDisabled] = useState(false)
  const affiliate = searchParams.get('affiliate')
  const extraValues = !!affiliate ? { affiliate } : {}

  return (
    <Form
      layout="vertical"
      onFinish={async (values) => {
        try {
          setSubmitDisabled(true)
          await onSubmit({ ...values, ...extraValues })
          // Reset submitDisabled if the submission is successful
          setSubmitDisabled(false)
        } catch (error) {
          // Reset submitDisabled to allow the user to try again
          setSubmitDisabled(false)
        }
      }}
      requiredMark={false}
      id="register"
    >
      <Title level={2}>
        {t('Login.NewUser')}
        <br />
        <strong>{t('Login.CreateAccount')}</strong>
      </Title>
      <Form.Item
        label={t('Login.FirstName')}
        name="first_name"
        rules={[
          {
            required: true,
            message: t('Register.error.PleaseEnterFirstName'),
          },
          {
            min: 2,
            message: t('Register.error.MinFirstName'),
          },
        ]}
      >
        <Input placeholder={t('Login.FirstName.placeholder')} />
      </Form.Item>
      <Form.Item
        label={t('Login.LastName')}
        name="last_name"
        rules={[
          {
            required: true,
            message: t('Register.error.PleaseEnterLastName'),
          },
          {
            min: 2,
            message: t('Register.error.MinLastName'),
          },
        ]}
      >
        <Input placeholder={t('Login.LastName.placeholder')} />
      </Form.Item>
      <Form.Item
        name="email"
        label={t('Login.NewEmail')}
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterEmail'),
          },
          {
            type: 'email',
            message: t('Register.error.PleaseEnterValidEmail'),
          },
        ]}
        hasFeedback
      >
        <Input placeholder={t('Login.NewEmail.placeholder')} />
      </Form.Item>
      <FormItemPasswordProgress
        placeholder={t('Login.NewPassword.placeholder')}
      />
      <br />
      <Form.Item
        label=""
        name="policy"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value
                ? Promise.resolve()
                : Promise.reject(new Error(t('Register.error.Policy'))),
          },
        ]}
      >
        <Checkbox>
          <span
            dangerouslySetInnerHTML={{ __html: t('Login.RegisteringPrivacy') }}
          ></span>
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <Col xs={24} sm={14} xl={12}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={submitDisabled}
            block
          >
            {t('Login.Register.button')}
          </Button>
        </Col>
      </Form.Item>
    </Form>
  )
}

export default RegisterForm
